<template>
 <div class="relative" v-if="(curentUser.type==='Seller' || curentUser.type==='Admin')">
        <button @click="toggle" class="text-gray-900 formation mr-4 mt-2 flex flex-row items-center w-full text-sm font-semibold text-left bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:focus:bg-gray-600 dark-mode:hover:bg-gray-600 md:w-auto md:inline  md:ml-4 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline">
         <span class="cursor-pointer flex items-center i18n-locale">
            <img class="blob green-2" src="https://img.icons8.com/color/96/000000/youtube-play.png"/>
         </span>
        </button>
        
  </div>   
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
 mixins: [clickaway],
 props:{
    user:{type:Object},
  },
  data() {
    return { 
      open: false,
      curentUser:this.user,
    };
  },
   async mounted() {
     
   },
  computed: {
    
  },
  methods: {
    async toggle() {
       this.$vm2.open('ModalFormation');
    },
  }
}
</script>
<style scoped>

.blob.green-2 {
  box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: pulse-green 2s infinite;
}
.formation img{
  width: 28px;
}
.dropdown_warhouse{
  min-width: 170px;
}
@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
  }
}
.vs-dropdown--item {
    text-align: left;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    position: relative;
    z-index: 100;
    border-radius: 5px;
    width: calc(100% - 6px);
    margin: 0 3px;
    list-style: none;
    font-weight: 400!important;
    font-size: .9375em;
}
 .vs-dropdown--item-link {
    display: flex;
    -moz-box-align: center;
    align-items: center;
    -moz-box-pack: justify;
    justify-content: space-between;
    padding: 5px 1px;
    cursor: pointer;
}
.vs-dropdown--menu{
border: 1px solid rgba(0,0,0,.1);
position: relative;
}
.vs-dropdown--menu--after {
    top: 0;
    right: 30px;
    position: absolute;
    width: 10px;
    height: 10px;
    display: block;
    background: #fff;
    -webkit-transform: rotate(
45deg
) translate(-7px);
    transform: rotate(
45deg
) translate(-7px);
    border-top: 1px solid rgba(0,0,0,.1);
    border-left: 1px solid rgba(0,0,0,.1);
    z-index: 10;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.checkboxWrapper{
    height: 20px;
    width: 20px;
    margin-left: 10px;
}
</style>